/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetDailyProgramItemsSuccessfulActionPayload,
  GetDailyProgramItemByIdActionPayload,
  GetDailyProgramItemByIdSuccessfulActionPayload,
  GetActiveDailyProgramItemWithRelationsByIdActionPayload,
  GetActiveDailyProgramItemByIdWithRelationsSuccessfulActionPayload,
  CreateDailyProgramItemActionPayload,
  CreateDailyProgramItemSuccessfulActionPayload,
  UpdateDailyProgramItemActionPayload,
  UpdateDailyProgramItemSuccessfulActionPayload,
  DeleteDailyProgramItemActionPayload,
  DeleteDailyProgramItemSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/daily-program-item-data-store';

/* action types */
export enum ActionTypes {
  InitFetchingActiveDailyProgramItemWithRelations = '[DAILYPROGRAMITEM] InitFetchingActiveDailyProgramItemWithRelations',
  GetDailyProgramItems = '[DAILYPROGRAMITEM] GetDailyProgramItems',
  GetDailyProgramItemsSuccessful = '[DAILYPROGRAMITEM] GetDailyProgramItemsSuccessful',
  GetDailyProgramItemsFailure = '[DAILYPROGRAMITEM] GetDailyProgramItemsFailure',
  GetDailyProgramItemById = '[DAILYPROGRAMITEM] GetDailyProgramItemById',
  GetDailyProgramItemByIdSuccessful = '[DAILYPROGRAMITEM] GetDailyProgramItemByIdSuccessful',
  GetDailyProgramItemByIdFailure = '[DAILYPROGRAMITEM] GetDailyProgramItemByIdFailure',
  GetActiveDailyProgramItemWithRelationsById = '[DAILYPROGRAMITEM] GetActiveDailyProgramItemWithRelationsById',
  GetActiveDailyProgramItemByIdWithRelationsSuccessful = '[DAILYPROGRAMITEM] GetActiveDailyProgramItemByIdWithRelationsSuccessful',
  GetActiveDailyProgramItemByIdWithRelationsFailure = '[DAILYPROGRAMITEM] GetActiveDailyProgramItemByIdWithRelationsFailure',
  CreateDailyProgramItem = '[DAILYPROGRAMITEM] CreateDailyProgramItem',
  CreateDailyProgramItemSuccessful = '[DAILYPROGRAMITEM] CreateDailyProgramItemSuccessful',
  CreateDailyProgramItemFailure = '[DAILYPROGRAMITEM] CreateDailyProgramItemFailure',
  UpdateDailyProgramItem = '[DAILYPROGRAMITEM] UpdateDailyProgramItem',
  UpdateDailyProgramItemSuccessful = '[DAILYPROGRAMITEM] UpdateDailyProgramItemSuccessful',
  UpdateDailyProgramItemFailure = '[DAILYPROGRAMITEM] UpdateDailyProgramItemFailure',
  DeleteDailyProgramItem = '[DAILYPROGRAMITEM] DeleteDailyProgramItem',
  DeleteDailyProgramItemSuccessful = '[DAILYPROGRAMITEM] DeleteDailyProgramItemSuccessful',
  DeleteDailyProgramItemFailure = '[DAILYPROGRAMITEM] DeleteDailyProgramItemFailure',
  ResetState = '[DAILYPROGRAMITEM] ResetState',
}

/* actions */

export const InitFetchingActiveDailyProgramItemWithRelations = createAction(
  ActionTypes.InitFetchingActiveDailyProgramItemWithRelations,
);

/* This event gets the all DailyProgramItems. */
export const GetDailyProgramItems = createAction(
  ActionTypes.GetDailyProgramItems,
);

/* This event is fired after getting all the DailyProgramItems successfully. */
export const GetDailyProgramItemsSuccessful = createAction(
  ActionTypes.GetDailyProgramItemsSuccessful,
  props<{ payload: GetDailyProgramItemsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the DailyProgramItems. */
export const GetDailyProgramItemsFailure = createAction(
  ActionTypes.GetDailyProgramItemsFailure,
);

/* This event gets the DailyProgramItem by DailyProgramItem id. */
export const GetDailyProgramItemById = createAction(
  ActionTypes.GetDailyProgramItemById,
  props<{ payload: GetDailyProgramItemByIdActionPayload }>(),
);

/* This event is fired after getting DailyProgramItem by DailyProgramItem id successfully. */
export const GetDailyProgramItemByIdSuccessful = createAction(
  ActionTypes.GetDailyProgramItemByIdSuccessful,
  props<{ payload: GetDailyProgramItemByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the DailyProgramItem by DailyProgramItem id. */
export const GetDailyProgramItemByIdFailure = createAction(
  ActionTypes.GetDailyProgramItemByIdFailure,
);

/* This event gets the active DailyProgramItem by DailyProgramItem id. */
export const GetActiveDailyProgramItemWithRelationsById = createAction(
  ActionTypes.GetActiveDailyProgramItemWithRelationsById,
  props<{ payload: GetActiveDailyProgramItemWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting DailyProgramItem by DailyProgramItem id successfully. */
export const GetActiveDailyProgramItemByIdWithRelationsSuccessful =
  createAction(
    ActionTypes.GetActiveDailyProgramItemByIdWithRelationsSuccessful,
    props<{
      payload: GetActiveDailyProgramItemByIdWithRelationsSuccessfulActionPayload;
    }>(),
  );

/* This event is fired after couldn't get the DailyProgramItem by DailyProgramItem id. */
export const GetActiveDailyProgramItemByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveDailyProgramItemByIdWithRelationsFailure,
);

/* This event creates a DailyProgramItem. */
export const CreateDailyProgramItem = createAction(
  ActionTypes.CreateDailyProgramItem,
  props<{ payload: CreateDailyProgramItemActionPayload }>(),
);

/* This event is fired after creating a DailyProgramItem successfully. */
export const CreateDailyProgramItemSuccessful = createAction(
  ActionTypes.CreateDailyProgramItemSuccessful,
  props<{ payload: CreateDailyProgramItemSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a DailyProgramItem successfully. */
export const CreateDailyProgramItemFailure = createAction(
  ActionTypes.CreateDailyProgramItemFailure,
);

/* This event updates a DailyProgramItem. */
export const UpdateDailyProgramItem = createAction(
  ActionTypes.UpdateDailyProgramItem,
  props<{ payload: UpdateDailyProgramItemActionPayload }>(),
);

/* This event is fired after updating a DailyProgramItem successfully. */
export const UpdateDailyProgramItemSuccessful = createAction(
  ActionTypes.UpdateDailyProgramItemSuccessful,
  props<{ payload: UpdateDailyProgramItemSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a DailyProgramItem successfully. */
export const UpdateDailyProgramItemFailure = createAction(
  ActionTypes.UpdateDailyProgramItemFailure,
);

/* This event deletes a DailyProgramItem. */
export const DeleteDailyProgramItem = createAction(
  ActionTypes.DeleteDailyProgramItem,
  props<{ payload: DeleteDailyProgramItemActionPayload }>(),
);

/* This event is fired after deleting a DailyProgramItem successfully. */
export const DeleteDailyProgramItemSuccessful = createAction(
  ActionTypes.DeleteDailyProgramItemSuccessful,
  props<{ payload: DeleteDailyProgramItemSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a DailyProgramItem successfully. */
export const DeleteDailyProgramItemFailure = createAction(
  ActionTypes.DeleteDailyProgramItemFailure,
);

/* This event resets the DailyProgramItem state. */
export const ResetState = createAction(ActionTypes.ResetState);
